export { CreateKidsWaypoint } from './CreateKidsWaypoint.component';
